import Service from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';
import Circuits from '@ebiz/aditools-schematic';

type SVGPreparedCircuit = ReturnType<typeof Circuits.prepare>;

export default class SvgCacheService extends Service {
  circuit: Record<string, Promise<SVGPreparedCircuit | null>> = {};

  _loadSVG(path: string): Promise<SVGPreparedCircuit | null> {
    return waitForPromise(
      Circuits.loadFile(path).then((svg) => {
        return svg ? Circuits.prepare(svg) : null;
      }),
      path,
    );
  }

  getSVG(path: string): Promise<SVGPreparedCircuit | null> {
    let value = this.circuit[path];
    if (!value) {
      value = this._loadSVG(path);
      this.circuit[path] = value;
    }
    return value;
  }
}

declare module '@ember/service' {
  interface Registry {
    'svg-cache': SvgCacheService;
  }
}
